import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const FinanceModeIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M8.34617 12.9577V6.34619H10.6538V12.9577L9.49999 11.8461L8.34617 12.9577ZM13.0192 14.8231V2.34619H15.3269V12.5154L13.0192 14.8231ZM3.65389 17.6192V10.3462H5.96152V15.3115L3.65389 17.6192ZM3.59619 20.8L9.46922 14.927L13.0192 17.977L19.1962 11.8H17.25V10.3H21.75V14.8H20.25V12.8538L13.0808 20.0231L9.53077 16.9731L5.70384 20.8H3.59619Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
